import React from "react";
import "react-tabs/style/react-tabs.css";
import { Form } from "react-bootstrap";
import { Button } from "react-bootstrap";
import { Card } from "react-bootstrap";
import { Col } from "reactstrap"; //CardImg,
import { Breadcrumb } from "react-bootstrap";
import MUIDataTable from "mui-datatables";
import { connect } from "react-redux";
import Razorpay from 'razorpay';
import Axios from 'axios';
import { Badge } from "react-bootstrap";
import dateFormat from 'dateformat';
import { toast } from 'react-toastify';
import { logincheck } from '../Userlogin/Userlogin'

class Wallettransaction extends React.Component {
  state = {};
  constructor(props) {
    super(props);
    this.state = {
      "pay_amount":"",
      "amount": "",
      tabs: ["", "", ""],
      tabPanel: ["", "", ""],
      tabPanel0: "", 
      tabPanel1: "",
      tabPanel2: "",
      wal_amount: 0,
      modal: false,
      userData: [],
      paymentData: [],
    };
    this.changeAmount = this.changeAmount.bind(this);
    this.openCheckout = this.openCheckout.bind(this);
    // this.submitHandler = this.submitHandler.bind(this);
  }

  nextPath(path, value) {
    this.props.history.push({ pathname: path, data: value, state: { data: value } });
  }

  changeAmount(e) {
    this.setState({ pay_amount: e.target.value});
    this.setState({amount: 100 * e.target.value})
  }

  openCheckout() {
    let options = {
      "key": 'rzp_live_k1946osZPf4RML',
      "amount": this.state.amount, // 2000 paise = INR 20, amount in paisa
      "name": "Gowatr",
      "user_d": this.props.userId,
      "description": "Add Money",
      "image": "/media/logos/drop2.png",
      handler: async (response) => {
        try {
          const API_URL = process.env.REACT_APP_NODE_ENV;
          const bodyParameters = { 
            amount_data: this.state.amount,
            acc_amount: this.state.pay_amount,  
            user_id: this.props.userId
         };
          

         const paymentId = response.razorpay_payment_id;
         const url = `${API_URL}/api/payment/${paymentId}`;
         const captureResponse = await Axios.post(url,bodyParameters, {})
         console.log(captureResponse.data);
         if(captureResponse.data) {
          this.props.history.push({ pathname: "/wallet/thankyou" });

         }
        } catch (err) {
          console.log(err);
        }
      },
      "theme": {
        "color": "#ffee00" 
      }
    };

    const rzp1 = new window.Razorpay(options);
       rzp1.open();
  }

  
  componentDidMount() {
	  
	logincheck(this.props.userId, this.props.mobiledevice).then(({ data: data }) => {
			console.log(data.status_check)
			if(data.status_check === 0) {
				this.props.history.push({ pathname: `/Logout`, state: { userId : this.props.userId , logintoken: 2 } });
			}
		}) 
	 let userdetails = { user_id : this.props.userId }
	   
    fetch(process.env.REACT_APP_NODE_ENV + '/api/customer/get_profile', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
      },
      body: JSON.stringify(userdetails)
    }).then((response) => response.json())
      .then(data => {
		  
		 
        
        
      }) 

    let postAddressData = { user_id : this.props.userId }
    fetch(process.env.REACT_APP_NODE_ENV + '/api/wallet/amount', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
      },
      body: JSON.stringify(postAddressData)
    }).then((response) => response.json())
      .then(data => {
        this.setState({ wal_amount : data.wallet_amount })
        //console.log(data.wallet_amount)
      })


      fetch(process.env.REACT_APP_NODE_ENV + '/api/wallet/transactionhistory', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
        },
        body: JSON.stringify(postAddressData)
      }).then((response) => response.json())
        .then(data => {
          this.setState({ paymentData : data })
           //console.log(data)

        })

      
   
  }

 

  render() {


    let dataArr = [];
    this.state.paymentData.map((data) => {
      let variant = "";
      let status = "";
      let transstatus ="";
      let variant1 = "";
       if (data.status === "captured" || data.status === "authorized" ) { status = "Success"; variant = "success" }
      if (data.transactionType === "deposit") { transstatus = "Add Money"; variant1 = "success" }
      else if (data.transactionType === "withdrawal") { transstatus = "withdraw"; variant1 = "danger"; status = "Success"; variant = "success"  }
	  else if (data.transactionType === "refund") { transstatus = "+ refund"; variant1 = "primary"; status = "Success"; variant = "success"  }


      let mdData = [
        data.payment_id,
        data.method, 'RS. '+data.transaction_amount, transstatus + '&&' + variant1, dateFormat(data.createdAt, 'dd-mmm-yyyy h:MM:ss TT'), status + '&&' + variant
      ];
      dataArr.push(mdData)
      return null;
    });

    const columns = [
      {
        name: "transactionid",
        label: "Transaction Id",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "paymentmode",
        label: "Payment Mode",
        options: {
          filter: true,
          sort: true,
        }
      },
      
      {
        name: "amount",
        label: "Amount",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "transactiontype",
        label: "Transaction Type",
        options: {
          filter: false,
          sort: true,
          download: false,
          customBodyRender: (value, tableMeta, updateValue) => {
            let datasFromValue = value.split("&&")
            return (<>  <Badge pill variant={datasFromValue[1]}>{datasFromValue[0]}</Badge>
            </>)
          }
        }
      },
      {
        name: "datetime",
        label: "Date Time",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "status",
        label: "Status",
        options: {
          filter: false,
          sort: true,
          download: false,
          customBodyRender: (value, tableMeta, updateValue) => {
            let datasFromValue = value.split("&&")
            return (<>  <Badge pill variant={datasFromValue[1]}>{datasFromValue[0]}</Badge>
            </>)
          }
        }
      }
    ];


    const options = {
      filterType: 'dropdown', rowsPerPageOptions: [5, 10, 15, 20], selectableRows: "none"
      // ,
      // onRowsDelete: (rowsDeleted) => {
      //   for (var key in rowsDeleted.data) {
      //     console.log(rowsDeleted.data[key].index)
      //     this.delete(dataArr[rowsDeleted.data[key].index].id)
      //   }
      // }
    };

 
  


    


    if (this.props.userRole === "Administrator" || this.props.userRole === "Super Admin" || this.props.userRole === "Support User" || this.props.userRole === "Individual Customer" ||  this.props.userRole == 'Apartment Customer' ) {
      return (
        <>
          <Breadcrumb>
            <Breadcrumb.Item active>Transaction History</Breadcrumb.Item>
          </Breadcrumb>

          <div style={{ marginTop: "10px" }}> 
          <div className="kt-form__section kt-form__section--first">
             <div className="kt-wizard-v1__form">


<MUIDataTable
              title={"Transaction History"}
              data={dataArr}
              columns={columns}
              options={options} />
              
                  </div> 
                
            </div>
           
          

          </div>
        </>
      );
    } else {
      return (<></>);
    }

  }
}

const mapStateToProps = (state /*, ownProps*/) => {
  return {
    userRole: state.auth.user[0].userType,
    userId: state.auth.user[0].id,
	mobiledevice: state.auth.user[0].mobiledeviceId,
  }
}

export default connect(
  mapStateToProps,
  null
)(Wallettransaction)